// extracted by css-extract-rspack-plugin
export default {"fieldset":"fieldset-137-v","required":"required-3WBpW"};